
import RequestAbstract from "../abstract";

export default class CryptoTopups extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/crypto/topups";
    }
}

